<template>
  <v-btn
    :color="color"
    depressed
    tile
    :class="`text-none py-6 px-8 ${textColor}`"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary",
    },
    textColor: {
      type: String,
      default: "white--text",
    },
  },
};
</script>
